export function useConfigurationAPI() {
  const { errors, request } = useRequestV2();

  async function getSiteConfiguration() {
    const url = 'V4/Configuration/SiteConfiguration';

    return await request<SiteConfiguration>(url);
  }

  async function getUserConfiguration() {
    const url = 'V4/Configuration/UserConfiguration';

    return await request<UserConfiguration>(url);
  }

  async function getUnits() {
    const url = 'V4/Configuration/GetUnits';

    return await request<Unit[]>(url);
  }

  async function getBankHolidays() {
    const url = 'V4/Configuration/GetBankHolidays';

    return await request<BankHoliday[]>(url);
  }

  async function UpsertLocale(locale: UserLocale) {
    const url = 'V4/Configuration/UpsertLocale';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: locale
    };

    return await request<number>(url, requestOptions);
  }

  return {
    errors,
    getUserConfiguration,
    getSiteConfiguration,
    getUnits,
    getBankHolidays,
    UpsertLocale
  };
}
